/**
 * NOTE: This file can be deleted once we have officially stopped building our legacay webpack bundle.
 */

/**
 * Create a mock for the named export `useRouter` hook provided from `next/router`.
 * This is because the actual module has dependencies that are specific to NextJS build processes and are incompatible
 * with our legacy application build. This approach allows us to continue using `next/router` within the sunsetting legacy build
 * and replaces all use of `router.push` with a plain browser navigation by setting the window.location.
 */
export const useRouter = () => ({
  push: (path) => {
    window.location = path;
  },
  // Mock query object to allow destructured assignment usage
  query: {}
});

export default {};
